import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioUsersStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-users', reducer),
        EffectsModule.forFeature([StudioUsersStoreEffects]),
    ],
    providers: [],
})
export class StudioUsersStoreModule { }
